var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/play_more.be108987.png","uri@2x": __webpack_public_path__ + "static/media/play_more.aa0ee2ff.png","uri@3x": __webpack_public_path__ + "static/media/play_more.2c3fd7f4.png",
    width: 52,
    height: 52
});